import React, { useState, useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import classes from './index.module.css'

export default function FeelDropdownList({
  selectedOption,
  setSelectedOption,
  collectionLength,
  optionsList,
  disabled,
}) {
  const [showOptionList, setShowOptionList] = useState(false)

  const selectContainerRef = useRef(null)
  const currentOptionList = optionsList.slice(0, collectionLength)

  useEffect(() => {
    const handleClickOutside = e => {
      if (
        selectContainerRef.current &&
        !selectContainerRef.current.contains(e.target)
      ) {
        setShowOptionList(false)
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
    if (disabled) {
      setShowOptionList(false)
    }
  }, [selectedOption, showOptionList, disabled])

  const handleListDisplay = () => {
    if (!disabled) {
      setShowOptionList(prevState => !prevState)
    }
  }

  const handleOptionClick = option => {
    setSelectedOption(option.value)
    setShowOptionList(false)
  }

  return (
    <div
      className={classes.container}
      ref={selectContainerRef}
      style={{
        opacity: disabled ? '0.7' : '1',
        cursor: disabled ? 'not-allowed' : 'pointer',
      }}
    >
      <div
        className={
          showOptionList ? `${classes.selectedText} ` : classes.selectedText
        }
        onClick={handleListDisplay}
      >
        {optionsList.find(item => item.value === selectedOption)?.label ||
          selectedOption}
      </div>
      {showOptionList && (
        <ul className={classes.selectOptions}>
          {currentOptionList.map(option => (
            <li
              key={option.value}
              onClick={() => handleOptionClick(option)}
              className={selectedOption === option.value ? classes.active : ''}
            >
              {option.label}
            </li>
          ))}
        </ul>
      )}
    </div>
  )
}

FeelDropdownList.propTypes = {
  selectedOption: PropTypes.number,
  setSelectedOption: PropTypes.func,
  collectionLength: PropTypes.number,
  optionsList: PropTypes.array,
  disabled: PropTypes.bool,
}
